import { render, staticRenderFns } from "./TaxSelect.vue?vue&type=template&id=4bd1499c&scoped=true"
import script from "./TaxSelect.vue?vue&type=script&lang=js"
export * from "./TaxSelect.vue?vue&type=script&lang=js"
import style0 from "./TaxSelect.vue?vue&type=style&index=0&id=4bd1499c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd1499c",
  null
  
)

export default component.exports